import * as React from "react";
import type { SVGProps } from "react";
const SvgQuestionSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#question-square_svg__a)">
      <path d="M11.99 15c-.55 0-1-.45-1-1v-1.32c0-.55.46-1 1.01-1 .49 0 .95-.19 1.3-.54s.54-.81.54-1.3-.19-.95-.54-1.3c-.7-.7-1.91-.69-2.6 0a.996.996 0 1 1-1.41-1.41c1.45-1.45 3.98-1.45 5.43 0 .73.73 1.12 1.69 1.12 2.72s-.4 1.99-1.12 2.72c-.48.48-1.07.82-1.71 1v.45c0 .55-.45 1-1 1zM12 18c-.26 0-.52-.11-.71-.29-.18-.19-.29-.44-.29-.71s.11-.52.29-.71a1.037 1.037 0 0 1 1.42 0c.18.19.29.45.29.71 0 .07 0 .13-.02.2 0 .06-.03.12-.06.18q-.03.09-.09.18c-.03.05-.08.1-.12.15-.19.18-.45.29-.71.29" />
      <path d="M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4M6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z" />
    </g>
    <defs>
      <clipPath id="question-square_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgQuestionSquare;
